import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from "../../../Common";
import services from "../services";
import authService from "../../Common/services";
import { LoadingSpinerComponent } from "../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import Joi from "@hapi/joi";
import { MobileDeviceConfigurationSchema } from "../MobileDeviceConfigurationSchema"
import { validateProperty, validate } from "../../Common";
import MessageModal from "../../../UI/Modal/MessageModal";
import tokenService from "../../../Common/tokenDecoder";

const screenCode = "MOBILEDEVICECONFIG";

export function MobileDeviceConfiguration(props) {
  const [groups, setGroups] = useState([]);
  const [operationEntity, setOperationEntity] = useState([]);
   const [multipleEstates, setMultipleEstates] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [employeeTypes, setEmployeeTypes] = useState([]);
  const [haverstingJobType, setHaverstingJobType] = useState([]);
  const [errors, setErrors] = useState({});
  const [permissionList, setPermissions] = useState({
    isAddEditEnabled: false,
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });
  const [istableHidden, setIstableHidden] = useState(true);
  const [qrTagDetails, setQrTagDetails] = useState([]);
  const [saveData, setSaveData] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Completed successfuly.",
  });
  const [qrTag, setQRTag] = useState({
    groupID: "0",
    operationEntityID: "0",
    routeID: "0",
  });
  const contentRowNames = ["userName", "imei", "division", "lockStatus"]

  const componentRef = useRef();

  const selectAll = () => {
    setCheckAll(!checkAll);
  };

  const schema = Joi.object(MobileDeviceConfigurationSchema).options({ allowUnknown: true });

  useEffect(() => {
    trackPromise(getPermissions());
  }, []);

  useEffect(() => {
    if (qrTag.groupID != 0 || qrTag.groupID != "") {
      trackPromise(getOperationEntityByGroup());
    }
  }, [qrTag.groupID]);

  useEffect(() => {
    trackPromise(
      getAllRoutesForDropDown()
    )
  }, [qrTag.operationEntityID]);

  useEffect(() => {
    setHaverstingJobType([])
    setQrTagDetails([])
    setIstableHidden(true)
  }, [qrTag.groupID, qrTag.operationEntityID, qrTag.routeID]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find((p) => p.permissionCode == "VIEWMOBILEDEVICECONFIGURATION");
    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }
    var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == "GROUPDROPDOWN");
    var isOperationEntityFilterEnabled = permissions.find((p) => p.permissionCode == "OPERATIONENTITYDROPDOWN");
    var isAddEditEnabled = permissions.find((p) => p.permissionCode == "LOCKMOBILEDEVICEPERMISSION");
    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
      isAddEditEnabled: isAddEditEnabled !== undefined,
    });
    var token = tokenService.getUserDetailsFromTokenV2();

    if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }
            setMultipleEstates(estateArray)
        }

    setQRTag({
      ...qrTag,
      groupID: token.groupID,
      operationEntityID: token.operationEntityID,
    });
    trackPromise(getGroupsForDropdown());
  }

  async function getGroupsForDropdown() {
    const result = await services.getAlGroupsForDropdown();
    setGroups(result);
  }

  async function getOperationEntityByGroup() {
    const data = await services.getOperationEntityByGroup(qrTag.groupID);
    setOperationEntity(data);
  }

  async function getAllRoutesForDropDown() {
    const routeList = await services.getCollectionPointByOperationEntityId(qrTag.groupID, qrTag.operationEntityID);
    setRoutes(routeList);
  }

  async function handleGenerate(e) {
    e.preventDefault();
    const errorMessages = validate(schema, qrTag);
    errorMessages !== null ? setErrors(errorMessages) : setErrors({});
    if (errorMessages) return;
    let model = {
      groupID: parseInt(qrTag.groupID),
      operationEntityID: parseInt(qrTag.operationEntityID),
      routeID: parseInt(qrTag.routeID),
    }
    const response = await services.getTags(model);
    if (response.length !== 0) {
      setQrTagDetails(response);
      setIstableHidden(false);
    } else {
      setMessageModel({
        ...messageModel,
        hidden: false,
        type: errorMessages,
        disciption: "No Record to display",
      });
      setIstableHidden(true);
      setTimeout(() => {
        setMessageModel({ ...messageModel, hidden: true })
      }, 1500);
    }
  }
  async function afterhandleGenerate(e) { 
    let model = {
      groupID: parseInt(qrTag.groupID),
      operationEntityID: parseInt(qrTag.operationEntityID),
      routeID: parseInt(qrTag.routeID),
    }
    const response = await services.getTags(model);
    if (response.length !== 0) {
      setQrTagDetails(response);
      setIstableHidden(false);
    } else {
      setMessageModel({
        ...messageModel,
        hidden: false,
        type: "Info",
        disciption: "No Record to display",
      });
      setIstableHidden(true);
      setTimeout(() => {
        setMessageModel({ ...messageModel, hidden: true })
      }, 1500);
    }
  }
  async function handleSave(e) {
    const response = await services.printQRtags(e); 
    if ((response.statusCode === "Success")) {
      setMessageModel({
        ...messageModel,
        hidden: false,
        type: response.statusCode,
        disciption: response.message,
      });
      setTimeout(() => {
        setMessageModel({ ...messageModel, hidden: true })
      }, 1500);
      setQrTagDetails([]);
      setIstableHidden(true); 
      afterhandleGenerate(e);
    }
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(target, MobileDeviceConfigurationSchema);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];
    setErrors(error);
  }

  function handleGroupChange(target) {
    validateInputs(target);

    setQRTag({
      ...qrTag,
      groupID: target.value,
      operationEntityID: "0",
      routeID: "0",
      noOfCodes: "0",
    });
  }

  function handleOperationEntityChange(target) {
    validateInputs(target);

    setQRTag({
      ...qrTag,
      operationEntityID: target.value,
      routeID: "0",
      noOfCodes: "0",
    });
  }

  function handleChange(e) {
    e.preventDefault();
    const target = e.target;
    const value = target.value;
    const error = { ...errors };
    const errorMessage = validateProperty(target, MobileDeviceConfigurationSchema);
    errorMessage ? error[target.name] = errorMessage : delete error[target.name];
    setQRTag({
      ...qrTag,
      [e.target.name]: value
    })
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  function handleClick(data) {
    if (data.isActive) {
      trackPromise(handleSave(data));
    }
    else {
      if (permissionList.isAddEditEnabled) {
        trackPromise(handleSave(data));
      }
      else {
        setMessageModel({
          ...messageModel,
          hidden: false,
          type: "Warning",
          disciption: "You do not have the required permissions.",
        });
        setTimeout(() => {
          setMessageModel({ ...messageModel, hidden: true })
        }, 1500);
      }
    }
  }

  const content = (da) => contentRowNames.map((row, index) => {
    return (
      (row === "isActive" ?
        (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>)
        : <td key={index}>{da[row] + " "}</td>
      )
    )
  });

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <PageHeader
              title="Mobile Device Configuration"
            />
            <div className="card-body">
              <form
                onSubmit={(e) => trackPromise(handleGenerate(e))}
                disabled={false}
              >
                <div className="form-group row">
                  <div className="col-md pb-1">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="groupID"
                      id="groupID"
                      name="groupID"
                      value={qrTag.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText error>{errors["groupID"]}</FormHelperText>
                    )}
                  </div>
                  <div className="col-md pb-1">
                    <InputLabel shrink id="operationEntityID">
                      Operation Entity *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="operationEntityID"
                      id="operationEntityID"
                      name="operationEntityID"
                      value={qrTag.operationEntityID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) => handleOperationEntityChange(e.target)}
                    >
                      <MenuItem value="0">--Select Operation Entity--</MenuItem>
                      {generateDropDownMenu(multipleEstates.length == 0 ? operationEntity : multipleEstates)}
                    </Select>
                    {errors["operationEntityID"] && (
                      <FormHelperText error>
                        {errors["operationEntityID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md pb-1">
                    <InputLabel shrink id="routeID">Collection Point</InputLabel>
                    <Select
                      fullWidth
                      id="routeID"
                      name="routeID"
                      value={qrTag.routeID}
                      onChange={(e) => handleChange(e)}>
                      <MenuItem value="0">--Collection Point--</MenuItem>
                      {generateDropDownMenu(routes)}
                    </Select>
                    {errors["routeID"] && <FormHelperText error>{errors["routeID"]}</FormHelperText>}
                  </div>
                </div>
                <div className="card-footer">
                  <input
                    type="submit"
                    className="btn btn-primary"
                    value="Search"
                  />
                </div>
              </form>
              <div hidden={istableHidden} >
                <div className="row">
                  <div className="col-md-12">
                    <div className="table-responsive row-top-gap">
                      <table id="buyerTable" className="display dataTable no-footer">
                        <thead>
                          <tr>
                            <th>User Name</th>
                            <th>Device Key</th>
                            <th>Division</th>
                            <th>LockStatus</th>
                            <th>Lock/Unlock</th>
                          </tr>
                        </thead>
                        <tbody>
                          {qrTagDetails.map((data, i) => {
                            return (
                              <tr key={i}>
                                {content(data)}
                                {data.isActive ?
                                  <td onClick={() => handleClick(data)} style={{ cursor: "pointer" }}
                                    title={"Click to Lock"}>
                                    <i class="fa fa-unlock-alt"
                                      style={{ color: '#7ed957', fontSize: '12px' }}
                                    ></i>
                                  </td>
                                  :
                                  <td onClick={() => handleClick(data)} style={{ cursor: "pointer" }}
                                    title={"Click to Unlock"}>
                                    <i class="fa fa-lock"
                                      style={{ color: '#ee5547ff', fontSize: '12px' }}
                                    ></i>
                                  </td>
                                }
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
        clicked={modalDismissHandler}
      />
    </Fragment>
  );
}
